export const NAVBAR_LINKS: { href: string; text: string }[] = [
  {
    href: '/projects',
    text: 'Projects',
  },
  {
    href: '/about',
    text: 'About',
  },
  {
    href: '/now',
    text: 'Now',
  },
  {
    href: '/run',
    text: 'Run',
  },
]
